import $foreign from "./foreign.cjs";
var unsafeCoerce = $foreign.unsafeCoerce;
export { unsafeCoerce };
